// extracted by mini-css-extract-plugin
export default {"our_smoothies_content":"ourSmoothie_our_smoothies_content__57Itn"};